import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import EventsList from "./pages/EventsList";
import EventBooking from "./pages/EventBooking";
import FeralInnovators from "./pages/FeralInnovators";
import InnovatorsInvite from "./pages/InnovatorsInvite";
import InnovatorsConfirmed from "./pages/InnovatorsConfirmed";
import AdminInnovators from "./pages/AdminInnovators";
import VenueHire from "./pages/VenueHire";
import OurStory from "./pages/OurStory";
import Stays from "./pages/Stays";
import StayDetail from "./pages/StayDetail";
import { CookieBanner } from "./components/home/CookieBanner";
import EarnEnjoy from "./pages/EarnEnjoy";
import ParkingEvent from "./pages/ParkingEvent";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminEvents from "./pages/AdminEvents";
import AdminDiscounts from "./pages/AdminDiscounts";
import ScrollToTop from "./components/ScrollToTop";
import AddOnPayment from "./pages/AddOnPayment";
import FeralFest2027 from "./pages/FeralFest2027";
import Unbound from "./pages/Unbound";
import SpringFeralFest from "./pages/SpringFeralFest";
import ClarityReset from "./pages/ClarityReset";
import MakersPitch from "./pages/MakersPitch";

import AdminEmailSignatures from "./pages/AdminEmailSignatures";
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CookieBanner />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/events" element={<EventsList />} />
          <Route path="/events/raf-valley-family-day" element={<ParkingEvent />} />
          <Route path="/events/spring-feral-fest" element={<SpringFeralFest />} />
          <Route path="/events/clarity-reset" element={<ClarityReset />} />
          <Route path="/events/rebels-reset" element={<ClarityReset />} />
          <Route path="/events/feral-innovators" element={<FeralInnovators />} />
          <Route path="/events/feral-innovators/confirmed" element={<InnovatorsConfirmed />} />
          <Route path="/events/feral-innovators/invite/:token" element={<InnovatorsInvite />} />
          <Route path="/events/feral-innovators/book" element={<InnovatorsInvite />} />
          <Route path="/events/:slug/book" element={<EventBooking forceBooking />} />
          <Route path="/events/:slug" element={<EventBooking />} />
          <Route path="/the-team" element={<Navigate to="/our-story" replace />} />
          <Route path="/our-story" element={<OurStory />} />
          <Route path="/venue-hire" element={<VenueHire />} />
          <Route path="/stays" element={<Stays />} />
          <Route path="/feral-stays" element={<Navigate to="/stays" replace />} />
          <Route path="/feral-stays/:slug" element={<StayDetail />} />
          <Route path="/earn-and-enjoy" element={<EarnEnjoy />} />
          <Route path="/feral-fest-2027" element={<FeralFest2027 />} />
          <Route path="/unbound" element={<Unbound />} />
          <Route path="/makerspitch" element={<MakersPitch />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/add-ons" element={<AddOnPayment />} />
          <Route path="/add-ons/:type" element={<AddOnPayment />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/events" element={<AdminEvents />} />
          <Route path="/admin/email-signatures" element={<AdminEmailSignatures />} />
          <Route path="/admin/innovators" element={<AdminInnovators />} />
          <Route path="/admin/discounts" element={<AdminDiscounts />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
